// List of available events for setSocketNotification action
export const TICKET_CREATED = "TicketCreated";
export const TICKET_ESCALATED = "TicketEscalated";
export const TICKET_MERGED = "TicketMerged";
